import { Box, Typography, Button } from "@mui/material";
import styles from "./styles.module.scss";
import StepIcon from "../StepIcon";
import { useDeleteStepMutation } from "../../queries/useJourneyQuery";
import { useNotification } from "context/NotificationContext";
// import Tip from "../Tip";
import ZoomImageModal from "components/common/ZoomImageModal";
import NavigationImage from "../StepCard/assets/navigation_placeholder.png";
import StepPlaceholderImage from "../StepCard/assets/step_placeholder_dark.svg";
import { useState, useEffect } from "react";
import clsx from "clsx";
import { hasMissingAccessibilityText } from "../../utils/stepAccessibility";

const StepProperties = (props) => {
  const { step, journeyId, onSuccess } = props;
  const showNotification = useNotification();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const shouldHighlightMissingAccessibility = hasMissingAccessibilityText(step);
  const isNavigationStep =
    String(step?.type || "").trim().toLowerCase() === "navigation";
  const fallbackImage = isNavigationStep ? NavigationImage : StepPlaceholderImage;
  const stepImage = step?.image || fallbackImage;
  const { mutateAsync, isPending } = useDeleteStepMutation({
    stepId: step?.id,
    journeyId,
  });

  useEffect(() => {
    if (!step || step.steps) return;
    console.log("[Journey StepProperties] step:", step);
  }, [step]);

  const handleDelete = async () => {
    await mutateAsync();
    onSuccess();
    showNotification(`Step has been deleted successfully`, "success");
  };

  if (!step || step.steps) return null;

  return (
    <>
      <Box
        className={styles.container}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <Box
          className={clsx(
            styles.imageWrapper,
            shouldHighlightMissingAccessibility && styles.missingAccessibility
          )}
          onClick={() => setIsModalOpen(!isModalOpen)}
        >
          <img
            src={stepImage}
            className={styles.image}
            alt={step.label}
          />
        </Box>
        <Typography variant="body2" className={styles.title}>
          PROPERTIES
        </Typography>
        <Box className={styles.actionWrapper}>
          <Box className={styles.actionIconWrapper}>
            <StepIcon action={step.properties.actionType} />
          </Box>
          <Typography className={styles.action}>
            {step.properties.actionType}
          </Typography>
        </Box>
        <Typography className={styles.description}>
          {step.properties.description}
        </Typography>
        {shouldHighlightMissingAccessibility && (
          <Typography className={styles.warning}>
            This element lacks accessibility information, which may affect
            interaction reliability. Adding a clear label or text will improve
            automation stability.
          </Typography>
        )}
        <Box className={styles.buttonWrapper}>
          <Button
            color="secondary"
            variant="contained"
            className={styles.button}
            onClick={handleDelete}
            disabled={isPending}
          >
            DELETE STEP
          </Button>
        </Box>
      </Box>
      {/* <Tip title="To select multiple step cards, hold down Shift for Windows or Command for Mac." /> */}
      <Box onClick={(e) => e.stopPropagation()}>
        <ZoomImageModal
          isOpen={isModalOpen}
          handleClose={() => setIsModalOpen(false)}
          src={stepImage}
          title={step.label}
        />
      </Box>
    </>
  );
};

export default StepProperties;
